'use strict';

// ========================================
// CONTACT STARS - Background Animation
// ========================================

class ContactStars {
    constructor(canvasId) {
        this.canvas = document.getElementById(canvasId);
        if (!this.canvas) return;

        this.ctx = this.canvas.getContext('2d');
        this.stars = [];
        this.isActive = true;
        this.isMobile = window.innerWidth < 768;
        this.fpsLimit = this.isMobile ? 30 : 60;
        this.lastFrameTime = 0;

        this.init();
    }

    init() {
        this.resize();
        this.createStars();
        this.bindEvents();
        this.animate();
    }

    resize() {
        const parent = this.canvas.parentElement;
        this.canvas.width = parent.offsetWidth;
        this.canvas.height = parent.offsetHeight;
        this.createStars();
    }

    createStars() {
        this.stars = [];
        const density = this.isMobile ? 8000 : 4000;
        const count = Math.floor((this.canvas.width * this.canvas.height) / density);

        for (let i = 0; i < count; i++) {
            this.stars.push({
                x: Math.random() * this.canvas.width,
                y: Math.random() * this.canvas.height,
                size: Math.random() * 2 + 0.5,
                alpha: Math.random() * 0.6 + 0.2,
                phase: Math.random() * Math.PI * 2,
                speed: 0.008 + Math.random() * 0.02
            });
        }
    }

    bindEvents() {
        window.addEventListener('resize', () => this.resize());

        document.addEventListener('visibilitychange', () => this.checkActiveState());

        // PERFORMANCE: IntersectionObserver - pause when off-screen
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                this.isInViewport = entry.isIntersecting;
                this.checkActiveState();
            });
        }, { threshold: 0.1 });

        observer.observe(this.canvas.parentElement);

        // PERFORMANCE: MutationObserver - strict pause when section is inactive
        const sectionEl = this.canvas.closest('.section');
        if (sectionEl) {
            const classObserver = new MutationObserver(() => this.checkActiveState());
            classObserver.observe(sectionEl, { attributes: true, attributeFilter: ['class'] });
        }
    }

    checkActiveState() {
        const sectionEl = this.canvas.closest('.section');
        const isSectionActive = sectionEl ? sectionEl.classList.contains('section--is-active') : true;
        const shouldBeActive = this.isInViewport && !document.hidden && isSectionActive;

        if (shouldBeActive && !this.isActive) {
            this.isActive = true;
            this.animate();
        } else if (!shouldBeActive) {
            this.isActive = false;
        }
    }

    animate(currentTime) {
        if (!this.isActive) return;

        // FPS Throttling
        this.lastFrameTime = this.lastFrameTime || 0;
        const delta = currentTime - this.lastFrameTime;
        const interval = 1000 / this.fpsLimit;

        if (delta < interval) {
            requestAnimationFrame((t) => this.animate(t));
            return;
        }
        this.lastFrameTime = currentTime - (delta % interval);

        const ctx = this.ctx;
        const w = this.canvas.width;
        const h = this.canvas.height;
        ctx.clearRect(0, 0, w, h);

        this.stars.forEach(star => {
            star.phase += star.speed;
            const twinkle = (Math.sin(star.phase) + 1) * 0.5;
            const alpha = star.alpha * (0.3 + twinkle * 0.7);

            const x = star.x;
            const y = star.y;
            const size = star.size;

            ctx.beginPath();
            ctx.arc(x, y, size, 0, Math.PI * 2);
            ctx.fillStyle = `rgba(255, 255, 255, ${alpha})`;
            ctx.fill();

            // Subtle glow for larger stars - optimized (disabled on mobile)
            if (size > 1.2 && !this.isMobile) {
                const glowSize = size * 2.5;
                const gradient = ctx.createRadialGradient(x, y, 0, x, y, glowSize);
                gradient.addColorStop(0, `rgba(200, 220, 255, ${alpha * 0.25})`);
                gradient.addColorStop(1, 'rgba(200, 220, 255, 0)');

                ctx.beginPath();
                ctx.arc(x, y, glowSize, 0, Math.PI * 2);
                ctx.fillStyle = gradient;
                ctx.fill();
            }
        });

        requestAnimationFrame((t) => this.animate(t));
    }
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        new ContactStars('contact-stars-canvas');
    }, 100);
});

// Reinitialize when navigating to section
$(document).ready(function () {
    $(document).on('click', '.side-nav li:nth-child(4), .outer-nav li:nth-child(4)', function () {
        setTimeout(() => {
            const canvas = document.getElementById('contact-stars-canvas');
            if (canvas && !canvas.hasAttribute('data-init')) {
                new ContactStars('contact-stars-canvas');
                canvas.setAttribute('data-init', 'true');
            }
        }, 500);
    });
});
